import { gql } from '@apollo/client'

export const SIGNIN = gql`
  mutation signIn($email: String!, $password: String!) {
    token: adminSignIn(email: $email, password: $password) {
      accessToken
      refreshToken
    }
  }
`
